import MessageReceiverTable from './MessageReceiverTable';
import './style/index.less';

export default MessageReceiverTable;
